import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'environments/environment';

declare global {
  interface Window {
    hsConversationsSettings?: {
      identificationEmail?: string;
      identificationToken?: string;
      [key: string]: unknown;
    };
  }
}
@Injectable({ providedIn: 'root' })
export class HubspotService {
  constructor(@Inject(DOCUMENT) private document: Document) {}
  private scriptId = 'hs-script-loader';

  loadTrackingScript(email?: string, token?: string): void {
    if (email && token) {
      window.hsConversationsSettings = window.hsConversationsSettings || {};
      window.hsConversationsSettings.identificationEmail = email;
      window.hsConversationsSettings.identificationToken = token;
    }
    if (!environment.hubspotTrackingId) {
      return;
    }

    const existingScript = this.document.getElementById(this.scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.id = this.scriptId;
    script.src = `https://js-eu1.hs-scripts.com/${environment.hubspotTrackingId}.js`;

    this.document.body.appendChild(script);
  }
}
